import React, { useEffect, useRef, useState, useCallback } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";
import {
  formatAmountComma,
  formatAmountForInput,
  validateAmountValue,
  parseAmountNumber,
} from "../../../../../utils/decimalAmountUtils";
import { getAllAutoSaveWorkentries } from "../../../../../store/slices/autosaveSlice";
import { getAllAssemblyInventory } from "../../../../../store/slices/assemblyInventorySlice";
import { fetchHardwareDescriptions, replaceAllHardwareDescriptions } from "../../../../../store/slices/hardwareDescriptionSlice";
import { replaceAllDescriptionTasks } from "../../../../../store/slices/descriptionTaskSlice";
import { updateTaskStatus } from "../../../../../store/slices/projectTaskStatusSlice";
import { submitWorkEntries } from "../../../../../store/slices/Entries&DescriptionSubmitByOm";
import AdminLoader from "../../../../../components/common/loader/AdminLoader";
import SubmitLoader from "../../../../../components/common/loader/SubmitLoader";
import { fetchGroups } from "../../../../../store/slices/groupSlice";
import { isTrainingExpenseDisplayRow } from "../../../../../utils/trainingOtherExpenseSync";

const ManagerHardware = ({
  handlerehardfresh,
  handlerefreshagain,
  hardwareData,
  employees,
  entries,
  tasks,
  items,
  row,
  Action,
  setAction,
  hardwareAction,
  setHardwareAction,
  handlerefresh,
  taskTableRowId
}) => {
  const maintaskdivRef = useRef(null);
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();
  const [projectname, setProjectname] = useState("");
  const [projectId, setProjectID] = useState("");
  const [, setTypeservice] = useState("");
  const [isLoading, SetisLoading] = useState(false);
  const [typingTimeout, setTypingTimeout] = React.useState(null);
  const [Assignperson, setAssignperson] = useState("");
  const [triprows, setTripRows] = useState([
    { description: "", value: "", notes: "" },
  ]);

  const [hardware, setHardware] = useState([{
    assemblepartdescription: "",
    partno: "",
    quantity: "",
    unitprice: "",
    totalprice: "",
  },]);
  const [fetchedHardwareData, setfetchedHardwareData] = useState([]);
  useEffect(() => {
    setProjectID(row._id)
    setProjectname(row.ProjectName);
    setTypeservice(row.TypeService);
  }, [row]);

  const [filteredEntries, setFilteredEntries] = useState([]);
  const { autosaveentries } = useSelector((state) => state.autosave);
  const [totalDollerValue, settotalDollerValue] = useState(0);
  const { mytrainings } = useSelector((state) => state.myTrainings);
  const { inventory } = useSelector((state) => state.assemblyInventory);

  const lockedTrainingRow = React.useMemo(() => {
    const resolveTrainingRefId = (ref) => {
      if (ref == null || ref === "") return "";
      if (typeof ref === "object") {
        const id = ref?._id ?? ref?.id;
        return id != null ? String(id).trim() : "";
      }
      return String(ref).trim();
    };

    const trainingsList = (() => {
      const raw = mytrainings;
      if (!raw) return [];
      if (Array.isArray(raw.trainings)) return raw.trainings;
      if (Array.isArray(raw?.data?.trainings)) return raw.data.trainings;
      if (Array.isArray(raw)) return raw;
      return [];
    })();

    const loggedEmail = String(localStorage.getItem("email") || "").trim().toLowerCase();
    const loggedEmp = (employees || []).find(
      (e) => String(e?.EmpEmail || "").trim().toLowerCase() === loggedEmail
    );
    if (!loggedEmp?._id) return null;

    const projectId = String(row?._id || row?.ProjectID || "").trim().toLowerCase();
    const quotationId = String(row?.quotationId || row?.quotationID || row?.quotationid || "").trim();
    const projectName = String(row?.ProjectName || row?.projectname || "").trim().toLowerCase();
    const rowLeadId = String(row?.leadid || row?.leadId || "").trim();
    const loggedAssigneeId = resolveTrainingRefId(loggedEmp._id);

    const assigneeMatchesTraining = (assigneeRaw) => {
      const aid = resolveTrainingRefId(assigneeRaw);
      if (aid && aid === loggedAssigneeId) return true;
      if (typeof assigneeRaw === "object" && assigneeRaw) {
        const em = String(
          assigneeRaw.EmpEmail || assigneeRaw.email || ""
        )
          .trim()
          .toLowerCase();
        if (em && em === loggedEmail) return true;
      }
      if (typeof assigneeRaw === "string" && assigneeRaw.includes("@")) {
        if (assigneeRaw.trim().toLowerCase() === loggedEmail) return true;
      }
      return false;
    };

    const matched = trainingsList.filter((t) => {
      if (!assigneeMatchesTraining(t?.assignedto ?? t?.assignedTo)) return false;

      const tProjectId = resolveTrainingRefId(
        t?.projectid ?? t?.projectId ?? t?.project
      ).toLowerCase();
      const tQuotationId = String(t?.quotationId ?? t?.quotationID ?? t?.quotationid ?? "").trim();
      const tProjectName = String(t?.projectname || "").trim().toLowerCase();
      const tLeadId = String(t?.leadid ?? t?.leadId ?? "").trim();

      return (
        (projectId && tProjectId && projectId === tProjectId) ||
        (quotationId && tQuotationId && quotationId === tQuotationId) ||
        (projectName && tProjectName && projectName === tProjectName) ||
        (rowLeadId && tLeadId && rowLeadId === tLeadId)
      );
    });

    const normalized = matched.map((t) => {
      const amount = Number(
        String(t?.trainingcost ?? t?.trainingCost ?? 0)
          .toString()
          .replace(/,/g, "")
      );
      const notes =
        t?.notes ??
        t?.note ??
        "";
      return {
        amount: Number.isFinite(amount) ? amount : 0,
        notes: String(notes || "").trim(),
      };
    });

    const total = normalized.reduce((sum, x) => sum + (Number(x.amount) || 0), 0);
    const joinedNotes = Array.from(
      new Set(normalized.map((x) => x.notes).filter(Boolean))
    ).join("; ");

    if (total <= 0 && !joinedNotes) return null;
    return {
      id: "training_cost",
      description: `Training Cost (${currency})`,
      amount: total,
      notes: joinedNotes,
    };
  }, [employees, mytrainings, row, currency]);

  const lockedTrainingCostTotal = lockedTrainingRow
    ? Number(lockedTrainingRow.amount) || 0
    : 0;
  const hasTrainingRowInTripRows = React.useMemo(
    () => (triprows || []).some((expenseRow) => isTrainingExpenseDisplayRow(expenseRow)),
    [triprows]
  );

  const lastEditableTripRowIndex = React.useMemo(() => {
    for (let i = triprows.length - 1; i >= 0; i -= 1) {
      if (!isTrainingExpenseDisplayRow(triprows[i])) return i;
    }
    return -1;
  }, [triprows]);
  const shouldShowLockedTrainingRows =
    !hasTrainingRowInTripRows &&
    (lockedTrainingCostTotal > 0 ||
      String(lockedTrainingRow?.notes || "").trim() !== "");
  const { group: groups } = useSelector((state) => state.group);
  // Operation-person "self" hardware rows for this project (used for consolidated view logic)
  const [operationHardware, setOperationHardware] = useState([]);

  useEffect(() => {
    if (triprows.length === 0) {
      setTripRows([{ description: "", value: "", notes: "" }]);
    }
  }, [triprows, setTripRows]);

  const [initialEdit, setInitialEdit] = useState(false);
  const lastSyncedProjectIdRef = useRef(null);

  useEffect(() => {
    if (row && row.Assignedperson) {
      const userEmail = localStorage.getItem('email');
      const assignedPerson = row.Assignedperson.find(
        person => person.email === userEmail
      );
      setAssignperson(assignedPerson)
    }
  }, [row]);

  useEffect(() => {
    if (!row?._id) return;
    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    if (!currentEmployee) return;
    const matchedtaskEntries = autosaveentries.filter(
      (entry) =>
        entry.projectid === row._id &&
        entry.taskownerid === currentEmployee._id
    );
    const matchedexpensesEntries = tasks.filter(
      (entry) =>
        entry.projectid === row._id &&
        entry.taskownerid === currentEmployee._id
    );
    const matchedhardwareEntries = items.filter(
      (entry) =>
        entry.projectid === row._id &&
        entry.taskownerid === currentEmployee._id
    );
    if (matchedtaskEntries.length) {
      setFilteredEntries(matchedtaskEntries);
    } else if (matchedexpensesEntries.length) {
      setFilteredEntries(matchedexpensesEntries);
    } else if (matchedhardwareEntries.length) {
      setFilteredEntries(matchedhardwareEntries);
    }
  }, [entries, autosaveentries, employees, row, initialEdit, tasks, items]);

  useEffect(() => {
    dispatch(getAllAutoSaveWorkentries());
    dispatch(getAllAssemblyInventory());
    dispatch(fetchGroups());

  }, [dispatch]);

  const groupNameById = React.useMemo(() => {
    const map = new Map();
    (groups || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [groups]);

  const selectedGroupName = React.useMemo(() => {
    const groupId = row?.groupid?._id || row?.groupid;
    if (groupId && groupNameById.has(String(groupId))) {
      return groupNameById.get(String(groupId));
    }
    return row?.AssignedGroup || "";
  }, [row, groupNameById]);

  const projectGroupId = React.useMemo(() => {
    return String(
      row?.groupid?._id ||
        row?.groupid?.id ||
        row?.groupid ||
        row?.groupId?._id ||
        row?.groupId?.id ||
        row?.groupId ||
        ""
    );
  }, [row]);

  const isInventoryGroupMatch = useCallback(
    (entry) => {
      const inventoryGroupId = String(
        entry?.groupid?._id ||
          entry?.groupid?.id ||
          entry?.groupid ||
          entry?.groupId?._id ||
          entry?.groupId?.id ||
          entry?.groupId ||
          ""
      );

      if (projectGroupId && inventoryGroupId) {
        return projectGroupId === inventoryGroupId;
      }

      if (selectedGroupName) {
        return entry?.group === selectedGroupName;
      }

      return false;
    },
    [projectGroupId, selectedGroupName]
  );

  useEffect(() => {
    // Assembly dropdown: show only assemblies whose group matches the project's AssignedGroup
    const matchedtaskEntries = inventory.filter((entry) =>
      isInventoryGroupMatch(entry)
    );
    
    const newhardwareRows = matchedtaskEntries?.map((hardware) => ({
      _id: hardware._id,
      assemblepartdescription: hardware.assembly || "",
      partnumber: hardware.partnumber || "",
      unitprice: hardware.unitprice || "",
    }));
    setfetchedHardwareData(newhardwareRows)
  }, [hardwareData, inventory, employees, row, isInventoryGroupMatch]);

  useEffect(() => {
    if (hardware.length === 0) {
      setHardware([{
        assemblepartdescription: "",
        partno: "",
        quantity: "",
        unitprice: "",
        totalprice: "",
      },])
    }
  }, [hardware, setHardware]);

  useEffect(() => {
    if (initialEdit) return;

    const loggedInUserEmail = localStorage.getItem("email");

    if (projectname && tasks.length > 0 && loggedInUserEmail) {
      const loggedInEmployee = employees.find(
        (emp) => emp.EmpEmail === loggedInUserEmail
      );

      if (loggedInEmployee) {
        const matchedTasks = tasks.filter(
          (task) => task.projectid === projectId
        );

        // Self view: consolidate other expenses across manager + assigned operation persons (by description)
        const manualTasks = matchedTasks.filter(
          (task) => !isTrainingExpenseDisplayRow(task)
        );

        const normalizeDescription = (description) =>
          String(description || "")
            .trim()
            .replace(/\s+/g, " ")
            .toLowerCase();

        const mergedTasksMap = manualTasks.reduce((acc, task) => {
          const normalizedKey = normalizeDescription(task?.description);
          if (!normalizedKey) return acc;

          const currentValue = Number(task?.value || 0);
          const safeValue = Number.isFinite(currentValue) ? currentValue : 0;

          if (acc[normalizedKey]) {
            acc[normalizedKey].value += safeValue;

            if (task?.notes) {
              const existingNotes = acc[normalizedKey].notes
                ? String(acc[normalizedKey].notes)
                    .split(" | ")
                    .map((n) => n.trim())
                : [];
              if (!existingNotes.includes(String(task.notes).trim())) {
                acc[normalizedKey].notes = [...existingNotes, String(task.notes).trim()]
                  .filter(Boolean)
                  .join(" | ");
              }
            }
          } else {
            acc[normalizedKey] = {
              ...task,
              description: String(task?.description || "").trim(),
              value: safeValue,
              notes: String(task?.notes || "").trim(),
            };
          }

          return acc;
        }, {});

        const newTripRows = Object.values(mergedTasksMap).map((task) => ({
          description: task.description || "",
          value: task.value ?? "",
          notes: task.notes || "",
        }));

        const total = newTripRows.reduce((sum, row) => {
          return sum + parseAmountNumber(row.value);
        }, 0);
        settotalDollerValue(total);
        setTripRows(
          newTripRows.length > 0
            ? [...newTripRows]
            : [{ description: "", value: "", notes: "" }]
        );
      }
    }
  }, [projectname, tasks, projectId, employees, initialEdit]);

  // Only sync hardware from items when project (row) changes, not when items
  // updates after autosave — otherwise the refetch overwrites local state and
  // Assembly/Part Description flickers to "Select option" after entering quantity.
  useEffect(() => {
    if (!row?._id) return;
    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    if (!currentEmployee) return;

    const isNewProject = lastSyncedProjectIdRef.current !== row._id;
    if (!isNewProject) return;

    lastSyncedProjectIdRef.current = row._id;

    if (items && items?.length > 0) {
      const projectItems = items.filter((item) => item.projectid === row._id);

      // Manager's own "self" hardware entries (what we will autosave/submit)
      const managerHardware = projectItems.filter((item) => {
        const ownerId = item?.taskownerid;
        const type = item?.tasktype;

        // No owner: treat as manager-owned (legacy data)
        if (ownerId == null || ownerId === "") {
          return true;
        }

        const isManagerOwner = String(ownerId) === String(currentEmployee._id);

        // Only keep manager's own "self" rows for this table
        if (isManagerOwner && (!type || type === "self")) {
          return true;
        }

        return false;
      });

      // Operation person "self" entries (used to decide which quantity wins per part)
      const operationSelfItems = projectItems.filter((item) => {
        const ownerId = item?.taskownerid;
        const type = item?.tasktype;
        if (!ownerId || String(ownerId) === String(currentEmployee._id)) {
          return false;
        }
        // Only use operation person's own "self" rows, ignore "other" (manager edits)
        return !type || type === "self";
      });

      setOperationHardware(operationSelfItems);

      setHardware(
        managerHardware.length > 0
          ? managerHardware
          : [
              {
                assemblepartdescription: "",
                partno: "",
                quantity: "",
                unitprice: "",
                totalprice: "",
                taskownerid: currentEmployee._id,
              },
            ]
      );
    } else {
      setOperationHardware([]);
      setHardware([
        {
          assemblepartdescription: "",
          partno: "",
          quantity: "",
          unitprice: "",
          totalprice: "",
          taskownerid: currentEmployee._id,
        },
      ]);
    }
  }, [items, row, employees]);

  const { enqueueSnackbar } = useSnackbar();

  const [isLoadingtask, setisLoadingtask] = useState(false);

  const handleAddRow = () => {
    if (triprows.length < 15) {
      setInitialEdit(true);
      setTripRows([...triprows, { description: "", value: "", notes: "" }]);
    } else {
      enqueueSnackbar("You can only add up to 15 rows.", { variant: "error" });
    }
  };

  const handleRemoveRow = (index) => {
    if (isTrainingExpenseDisplayRow(triprows[index])) return;

    const updatedRows = triprows.filter((_, i) => i !== index);
    setInitialEdit(true);
    setTripRows(updatedRows);
    const total = updatedRows.reduce((sum, row) => {
      return sum + parseAmountNumber(row.value);
    }, 0);
    settotalDollerValue(total);
    setTimeout(() => {
      handleDescriptionSubmitofManagerAuto(updatedRows);
    }, 2000);
  };

  // Only set default tab when the project row changes (row._id), not on every re-render,
  // so clicking "Other Expenses" is not overwritten by this effect.
  useEffect(() => {
    const hasHardware = Array.isArray(row?.TypeService)
      ? row.TypeService.some((service) => service.includes("Hardware"))
      : row.TypeService?.includes("Hardware");

    if (hasHardware) {
      setAction("");
      setHardwareAction("hardwarecost");
    } else {
      setAction("task");
      setHardwareAction("");
    }
  }, [row?._id, row?.TypeService, setAction, setHardwareAction]);

  const handleTripInputChange = (index, field, value) => {
    if (isTrainingExpenseDisplayRow(triprows[index])) return;

    const nextValue =
      field === "value" ? validateAmountValue(value) : value;
    const newRows = [...triprows];
    newRows[index][field] = nextValue;
    setTripRows(newRows);
    setInitialEdit(true);

    if (field === 'value') {
      const total = newRows.reduce((sum, row) => {
        return sum + parseAmountNumber(row.value);
      }, 0);
      settotalDollerValue(total);
    }
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    const newTimeout = setTimeout(() => {
      handleDescriptionSubmitofManagerAuto(newRows);
    }, 2000);

    setTypingTimeout(newTimeout);
  };

  const validateDescriptionOrNotes = (value) => {
    return value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
  };

  const handledirectSubmit = async () => {
    const email = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
    const projectid = row._id
    const taskownerid = currentEmployee?._id
    setisLoadingtask(true);
    try {
      await dispatch(submitWorkEntries({ projectid, taskownerid }));
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      dispatch(getAllAutoSaveWorkentries());
      setisLoadingtask(false);
    }
  };

  const updatebyname = useCallback(async () => {
    const email = localStorage.getItem("email");
    const updatedAssignedperson = (row.Assignedperson || [])
      .filter(person => person.email === email)
      .map(person => ({
        ...person,
        taskStatus: "submit",
      }));
    const filteredEmployee = employees.find((emp) => emp?.EmpEmail === updatedAssignedperson[0]?.email);
    const selectedProjectId = row?._id;
    const loggedInUserId = filteredEmployee?._id;

    setisLoadingtask(true);
    try {
      await dispatch(updateTaskStatus({
        projectid: selectedProjectId,
        userid: loggedInUserId
      }))
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      dispatch(getAllAutoSaveWorkentries());
      setisLoadingtask(false);
    }
  }, [dispatch, row, employees]);

  const handleDescriptionSubmitofManagerAuto = React.useCallback(async (newRows) => {
    const filteredRows = newRows.filter((row) => {
      if (isTrainingExpenseDisplayRow(row)) return false;
      return (
        (row.description && row.description.trim() !== "") ||
        (row.value && row.value.toString().trim() !== "") ||
        (row.notes && row.notes.trim() !== "")
      );
    });
    setisLoadingtask(true)
    try {
      const formdata = filteredRows.map((row) => ({
        description: row.description || "",
        value: row.value || "",
        notes: row.notes || "",
        taskstatus: "submit"
      }));
      await dispatch(replaceAllDescriptionTasks({
        projectid: projectId,
        tasktype: "self",
        entries: [...formdata]
      }));

    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      setisLoadingtask(false)
      setInitialEdit(false);
      dispatch(fetchHardwareDescriptions());
      handlerefreshagain()
    }
  }, [dispatch, projectId, handlerefreshagain]);


  const handleDescriptionSubmitofManager = React.useCallback(async () => {
    const editableRows = triprows.filter((row) => !isTrainingExpenseDisplayRow(row));
    // Drop blank placeholder rows; keep only rows with any meaningful data
    const filledRows = editableRows.filter((row) => {
      return (
        (row.description && row.description.trim() !== "") ||
        (row.value !== undefined && row.value !== null && row.value.toString().trim() !== "") ||
        (row.notes && row.notes.trim() !== "")
      );
    });
    // Partially filled rows (missing description or value) still block submit
    const hasEmptyFields = filledRows.some((row) => {
      return (
        !row.description?.trim() ||
        row.value === "" ||
        row.value === null ||
        row.value === undefined
      );
    });
    if (hasEmptyFields) {
      return;
    }
    setisLoadingtask(true)
    try {
      // Persist current list including [] so deleted Other Expenses clear on resubmit
      const formdata = filledRows.map((row) => ({
        description: row.description || "",
        value: row.value || "",
        notes: row.notes || "",
        taskstatus: "submit"
      }));
      await dispatch(replaceAllDescriptionTasks({
        projectid: projectId,
        tasktype: "self",
        entries: [...formdata]
      }));
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      setisLoadingtask(false)
      setInitialEdit(false);
      dispatch(fetchHardwareDescriptions());
    }
  }, [triprows, dispatch, projectId]);

  const handleAddHardware = () => {
    if (hardware.length >= 15) return;

    const email = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === email);

    setHardware([
      ...hardware,
      {
        assemblepartdescription: "",
        partno: "",
        quantity: "",
        unitprice: "",
        totalprice: "",
        taskownerid: currentEmployee?._id,
      },
    ]);
    resetTypingTimeout();
  };

  // Only rows with assembly + quantity are sent (avoids backend rejecting empty rows)
  const getValidManagerHardwareRows = useCallback((rows) => {
    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    return rows
      .filter(
        (item) =>
          item?.assemblepartdescription &&
          String(item.assemblepartdescription).trim() !== "" &&
          item?.quantity != null &&
          String(item.quantity).trim() !== "" &&
          Number(item.quantity) > 0
      )
      .map((item) => ({
        ...item,
        taskownerid: item.taskownerid || currentEmployee?._id,
      }));
  }, [employees]);

  const handlehardwaretaskAuto = useCallback(async (hardware) => {
    const validRows = getValidManagerHardwareRows(hardware);
    if (validRows.length === 0) return;

    const transformedData = validRows.map((item) => ({
      ...item,
      // Use the same autosave status label as Operation hardware
      taskstatus: "auto-save",
    }));
    const payload = {
      projectid: row._id,
      tasktype: "self",
      tasks: transformedData
    };
    setisLoadingtask(true)
    try {
      await dispatch(replaceAllHardwareDescriptions(payload));
    } catch (error) {
      console.error("Error submitting hardware:", error);
      throw error;
    } finally {
      setisLoadingtask(false)
      handlerehardfresh()
    }
  }, [row, dispatch, handlerehardfresh, getValidManagerHardwareRows]);
  const resetTypingTimeout = useCallback(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      handlehardwaretaskAuto(hardware);
    }, 3000);
    setTypingTimeout(newTimeout);
  }, [typingTimeout, hardware, handlehardwaretaskAuto]);

  const handleRemoveHardware = () => {
    const newHardware = [...hardware];
    newHardware.pop();
    setHardware(newHardware);
    setTimeout(() => {
      handlehardwaretaskAuto(newHardware); // Pass the updated rows directly
    }, 2000);
  };

  const handlehardwareInputChange = (index, key, value) => {
    const updated = [...hardware];
    if (key === "assemblepartdescription") {
      const selectedPart = fetchedHardwareData?.find(
        (item) => item.assemblepartdescription === value
      );
      if (selectedPart) {
        updated[index] = {
          ...updated[index],
          assemblepartdescription: selectedPart.assemblepartdescription,
          partno: selectedPart.partnumber,
          unitprice: selectedPart.unitprice.toString(),
          quantity: "", // Reset quantity to empty string
          totalprice: "", // Reset total price since quantity is now empty
        };
      } else {
        updated[index] = {
          ...updated[index],
          assemblepartdescription: value,
          partno: "",
          unitprice: "",
          quantity: "", // Reset quantity to empty string
          totalprice: "", // Reset total price
        };
      }
    } else if (key === "quantity") {
      const quantity = Number(value);
      const unitprice = Number(updated[index].unitprice || 0);

      updated[index] = {
        ...updated[index],
        quantity: value,
        totalprice:
          !isNaN(quantity) && quantity !== 0
            ? (unitprice * quantity).toFixed(2)
            : "0.00",
      };

      // Check stock availability when quantity is entered
      if (updated[index].assemblepartdescription && quantity > 0) {
        const matchingInventory = inventory.find(
          (item) =>
            isInventoryGroupMatch(item) &&
            item.assembly &&
            item.assembly.trim().toLowerCase() === updated[index].assemblepartdescription.trim().toLowerCase()
        );

        if (matchingInventory) {
          const availableStock = Number(matchingInventory.unitsAvailable || 0);
          if (quantity > availableStock) {
            enqueueSnackbar("Insufficient Stock", {
              variant: "error",
            });
          }
        }
      }
    } else {
      updated[index][key] = value;
    }
    setHardware(updated);
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      handlehardwaretaskAuto(updated);
    }, 3000);
    setTypingTimeout(newTimeout);
  };


  const handlehardwaretaskSubmit = useCallback(async (hardware) => {
    const validRows = getValidManagerHardwareRows(hardware);
    const transformedData = validRows.map((item) => ({
      ...item,
      taskstatus: "submit",
    }));
    const payload = {
      projectid: row._id,
      tasktype: "self",
      tasks: transformedData
    };
    setisLoadingtask(true)
    try {
      await dispatch(replaceAllHardwareDescriptions(payload));
    } catch (error) {
      console.error("Error submitting hardware:", error);
      throw error;
    } finally {
      setisLoadingtask(false)
    }
  }, [row, dispatch, getValidManagerHardwareRows]);

  const handleSelectOpen = () => {
    resetTypingTimeout();
  };

  const handleAction = async () => {
    // Check if any hardware row has assembly selected but quantity is missing
    const hasMissingQuantity = hardware.some((item) => {
      return item.assemblepartdescription && 
             item.assemblepartdescription.trim() !== "" && 
             (!item.quantity || item.quantity.toString().trim() === "" || Number(item.quantity) <= 0);
    });

    if (hasMissingQuantity) {
      enqueueSnackbar("Please Enter Quantity", {
        variant: "error",
      });
      SetisLoading(false);
      return;
    }

    SetisLoading(true);
    try {
      const serviceType = row.TypeService.toLowerCase();

      switch (true) {
        case serviceType.includes('installation'):
          await handledirectSubmit();
          await updatebyname()
          break;

        case serviceType.includes('hardware'):
          await handlehardwaretaskSubmit(hardware);
          await handleDescriptionSubmitofManager();
          await updatebyname()
          break;

        case serviceType.includes('software'):
        case serviceType.includes('cloud'):
          await handledirectSubmit();
          await handleDescriptionSubmitofManager();
          await updatebyname()
          break;

        default:
          await handledirectSubmit();
          await handleDescriptionSubmitofManager();
          await handlehardwaretaskSubmit(hardware);
          await updatebyname()
      }

      enqueueSnackbar("Response Submitted Successfully.", {
        variant: "success",
      });
      handlerefresh()
    } catch (error) {
      enqueueSnackbar("Error occurred: " + error.message, {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
    }
  };

  // Decide which row to show per part description:
  // - If only operation person exists for a part → show that row (read-only)
  // - If manager also adds same part:
  //    - If manager quantity > operation quantity → show manager row, hide operation
  //    - If manager quantity <= operation quantity → keep showing operation row,
  //      manager row is still saved but not shown in this table.
  const hardwareDisplayConfig = React.useMemo(() => {
    const managerByKey = {};
    const operationByKey = {};

    hardware.forEach((item, index) => {
      const key = (item?.assemblepartdescription || "").trim();
      if (!key) return;
      const existing = managerByKey[key];
      if (!existing || Number(item.quantity) > Number(existing.item.quantity || 0)) {
        managerByKey[key] = { item, index };
      }
    });

    operationHardware.forEach((item) => {
      const key = (item?.assemblepartdescription || "").trim();
      if (!key) return;
      const existing = operationByKey[key];
      if (!existing || Number(item.quantity) > Number(existing.quantity || 0)) {
        operationByKey[key] = item;
      }
    });

    const allKeys = Array.from(
      new Set([...Object.keys(managerByKey), ...Object.keys(operationByKey)])
    );

    const displayRows = [];
    const hiddenManagerIndices = new Set();

    allKeys.forEach((key) => {
      const managerEntry = managerByKey[key];
      const opEntry = operationByKey[key];

      const managerQty = Number(managerEntry?.item?.quantity || 0);
      const opQty = Number(opEntry?.quantity || 0);

      if (managerEntry && (!opEntry || managerQty > opQty)) {
        // Manager wins or is the only one
        displayRows.push({
          source: "manager",
          item: managerEntry.item,
          managerIndex: managerEntry.index,
        });
      } else if (opEntry && opQty > 0) {
        // Operation person has highest or equal quantity → show only operation row
        displayRows.push({
          source: "operation",
          item: opEntry,
          managerIndex: null,
        });
        if (managerEntry) {
          hiddenManagerIndices.add(managerEntry.index);
        }
      } else if (managerEntry) {
        // Fallback: only manager with non-positive op quantity
        displayRows.push({
          source: "manager",
          item: managerEntry.item,
          managerIndex: managerEntry.index,
        });
      }
    });

    const totalHardwareCost = displayRows.reduce((sum, row) => {
      return sum + Number(row.item.totalprice || 0);
    }, 0);

    return { displayRows, hiddenManagerIndices, totalHardwareCost };
  }, [hardware, operationHardware]);

  const { displayRows, hiddenManagerIndices, totalHardwareCost } = hardwareDisplayConfig;
  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
      <div className={` custom-scroll w-full h-full justify-center ${taskTableRowId === row?._id ? "min-h-[20vh]" : ""} max-h-[53vh] overflow-auto pb-5`} ref={maintaskdivRef}>
        { hardwareAction === "hardwarecost" && (
            <div className="mainhardwarekdiv w-full bg-white">
              <div className="w-full bg-white rounded-lg h-full justify-center pb-5">
                <div className="flex flex-col w-full">
                  <div className="w-full flex flex-col">
                    <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                      <div className="w-[10%] border p-1 flex justify-center align-middle items-center">Sr. No</div>
                      <div className="w-60 border py-1 break-words">
                        Assembly/Part Description
                      </div>
                      <div className="w-[20%] border p-1">Part No</div>
                      <div className="w-[20%] border p-1">Quantity</div>
                      <div className="w-[20%] border p-1">Unit Cost ({currency})</div>
                      <div className="w-[20%] border p-1">Total Cost ({currency})</div>
                    </div>
                    <div className="head flex text-center bg-blue-500  text-white text-[11px]">
                      <div className=" border w-[10%] p-1 break-all whitespace-normal"></div>
                      <div className=" border w-60 pt-1  break-all whitespace-normal">
                        Total
                      </div>
                      <div className=" border w-[20%]  break-all whitespace-normal  p-1">
                        {" "}
                      </div>
                      <div className=" border w-[20%] break-all whitespace-normal p-1"></div>
                      <div className=" border w-[20%] break-all whitespace-normal p-1">
                        {" "}
                      </div>
                      <div className=" border w-[20%] break-all whitespace-normal p-1">
                        {USAComma(totalHardwareCost)}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full">
                  {displayRows.map((config, index) => {
                    const row = config.item;
                    const serialNo = index + 1;

                    // Read-only consolidated row (operation person wins)
                    if (config.source === "operation" || Assignperson?.taskStatus === "submit") {
                      return (
                        <div
                          key={`display-${config.source}-${index}`}
                          className="flex items-center text-center w-full text-xs"
                        >
                          <div className="w-full">
                            <div className="head flex">
                              <div className="w-[10%] border p-1">{serialNo}</div>
                              <div className="w-60 border p-1 break-all whitespace-normal">
                                {row.assemblepartdescription || ""}
                              </div>
                              <div className="w-[20%] border p-1 break-all whitespace-normal">
                                {row.partno || ""}
                              </div>
                              <div className="w-[20%] border p-1 break-all whitespace-normal">
                                {row.quantity || ""}
                              </div>
                              <div className="w-[20%] border p-1 break-all whitespace-normal">
                                {USAComma(row.unitprice) || ""}
                              </div>
                              <div className="w-[20%] border p-1 break-all whitespace-normal">
                                {USAComma(row.totalprice || "")}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }

                    // Editable manager row that is currently the visible winner for this part
                    const managerIndex = config.managerIndex ?? 0;
                    const managerRow = hardware[managerIndex] || row;

                    return (
                      <div
                        key={`display-manager-${index}`}
                        className="flex items-center text-center w-full text-xs"
                      >
                        <div className="w-full">
                          <div className="head flex">
                            <div className="w-[10%] border p-1">{serialNo}</div>

                            {/* Description Select */}
                            <div className="w-60 border p-1 break-all whitespace-normal">
                              <select
                                name="assemblepartdescription"
                                value={managerRow.assemblepartdescription || ""}
                                onChange={(e) =>
                                  handlehardwareInputChange(
                                    managerIndex,
                                    "assemblepartdescription",
                                    e.target.value
                                  )
                                }
                                onFocus={handleSelectOpen}
                                className="outline-none text-black border-none bg-white text-center w-full h-full"
                              >
                                <option hidden value="">
                                  Select
                                </option>
                                {fetchedHardwareData?.map((option) => {
                                  const isAlreadySelected = hardware.some(
                                    (hRow, i) =>
                                      hRow.assemblepartdescription ===
                                        option.assemblepartdescription &&
                                      i !== managerIndex
                                  );

                                  return (
                                    <option
                                      key={option._id}
                                      value={option.assemblepartdescription}
                                      disabled={isAlreadySelected}
                                    >
                                      {option.assemblepartdescription}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>

                            {/* Part Number */}
                            <div className="w-[20%] border p-1 break-all whitespace-normal">
                              {managerRow.partno || "--"}
                            </div>

                            {/* Quantity Input */}
                            <div className="w-[20%] border p-1 break-all whitespace-normal">
                              <input
                                type="number"
                                placeholder="enter quantity "
                                value={managerRow.quantity || ""}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
                                    handlehardwareInputChange(
                                      managerIndex,
                                      "quantity",
                                      value
                                    );
                                  }
                                }}
                                onKeyDown={(e) => {
                                  // Block minus and other unwanted keys
                                  if (
                                    !(
                                      (e.key >= "0" && e.key <= "9") || // numbers
                                      e.key === "." || // decimal
                                      e.key === "Backspace" ||
                                      e.key === "Delete" ||
                                      e.key === "ArrowLeft" ||
                                      e.key === "ArrowRight" ||
                                      e.key === "Tab"
                                    )
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                className="w-full h-full border text-center border-gray-300 rounded-md p-0.5"
                              />
                            </div>

                            <div className="w-[20%] border p-1 break-all whitespace-normal">
                              {USAComma(managerRow.unitprice) || ""}
                            </div>

                            <div className="w-[20%] border p-1 truncate break-all whitespace-normal">
                              {USAComma(managerRow.totalprice || "")}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {/* Extra manager rows that are not part of displayRows (e.g. blank rows for new entries) */}
                  {hardware?.map((row, index) => {
                    if (hiddenManagerIndices.has(index)) return null;

                    const key = (row?.assemblepartdescription || "").trim();
                    const isRepresentedInDisplay = displayRows.some(
                      (cfg) =>
                        cfg.source === "manager" &&
                        cfg.managerIndex === index
                    );
                    if (isRepresentedInDisplay && key) return null;

                    // Allow manager to see/edit additional blank or new rows
                    if (Assignperson?.taskStatus === "submit") {
                      return null;
                    }

                    const serialNo = displayRows.length + index + 1;

                    return (
                      <div
                        key={`extra-manager-${index}`}
                        className="flex items-center text-center w-full text-xs"
                      >
                        <div className="w-full">
                          <div className="head flex">
                            <div className="w-[10%] border p-1">{serialNo}</div>
                            <div className="w-60 border p-1 break-all whitespace-normal">
                              <select
                                name="assemblepartdescription"
                                value={row.assemblepartdescription || ""}
                                onChange={(e) =>
                                  handlehardwareInputChange(
                                    index,
                                    "assemblepartdescription",
                                    e.target.value
                                  )
                                }
                                onFocus={handleSelectOpen}
                                className="outline-none text-black border-none bg-white text-center w-full h-full"
                              >
                                <option hidden value="">
                                  Select
                                </option>
                                {fetchedHardwareData?.map((option) => {
                                  const isAlreadySelected = hardware.some(
                                    (hRow, i) =>
                                      hRow.assemblepartdescription ===
                                        option.assemblepartdescription &&
                                      i !== index
                                  );

                                  return (
                                    <option
                                      key={option._id}
                                      value={option.assemblepartdescription}
                                      disabled={isAlreadySelected}
                                    >
                                      {option.assemblepartdescription}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>

                            <div className="w-[20%] border p-1 break-all whitespace-normal">
                              {row.partno || "--"}
                            </div>

                            <div className="w-[20%] border p-1 break-all whitespace-normal">
                              <input
                                type="number"
                                placeholder="enter quantity "
                                value={row.quantity || ""}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
                                    handlehardwareInputChange(index, "quantity", value);
                                  }
                                }}
                                onKeyDown={(e) => {
                                  if (
                                    !(
                                      (e.key >= "0" && e.key <= "9") || // numbers
                                      e.key === "." || // decimal
                                      e.key === "Backspace" ||
                                      e.key === "Delete" ||
                                      e.key === "ArrowLeft" ||
                                      e.key === "ArrowRight" ||
                                      e.key === "Tab"
                                    )
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                className="w-full h-full border text-center border-gray-300 rounded-md p-0.5"
                              />
                            </div>

                            <div className="w-[20%] border p-1 break-all whitespace-normal">
                              {USAComma(row.unitprice) || ""}
                            </div>

                            <div className="w-[20%] border p-1 truncate break-all whitespace-normal">
                              {USAComma(row.totalprice || "")}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {Assignperson?.taskStatus === "submit"
                    ? (
                      <></>
                    ) : (
                      <div className="flex justify-between px-2 pt-1">
                        <button
                          className="shadow-xl rounded-md p-1"
                          onClick={handleAddHardware}
                          disabled={hardware.length >= 15}
                        >
                          <AddIcon />
                        </button>
                        <button
                          className="shadow-xl rounded-md p-1"
                          onClick={handleRemoveHardware}
                        >
                          <RemoveIcon />
                        </button>
                      </div>)}
                </div>
              </div>
            </div>

          )
        }
        {
          ((hardwareAction === "otherexpenses") || ((Array.isArray(row.TypeService)
            ? row.TypeService.some((service) =>
              ["Software", "Cloud"].some((keyword) => service.includes(keyword))
            )
            : ["Software", "Cloud"].some((keyword) =>
              row.TypeService?.includes(keyword)
            )) && Action === "otherExpenses")) && (
            <div className="maintaskdiv w-full bg-white">
              <div className="w-full bg-white rounded-lg h-full justify-center pb-5">
                <div className="flex flex-col w-full">
                  <div className="w-full">
                    <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                      <div className="w-[10%] border p-1 flex justify-center align-middle items-center">Sr. No</div>
                      <div className="w-[40%] border p-2">Description </div>
                      <div className="w-[25%] border p-2">Amount ({currency})</div>
                      <div className="w-[25%] border p-2">Notes</div>
                    </div>
                  </div>
                  <div className="w-full">
                    <div className="head flex text-center  text-xs">
                      <div className="w-[10%] border p-1 flex justify-center align-middle items-center"></div>
                      <div className="w-[40%] border p-2">Total</div>
                      <div className="w-[25%] border p-2">
                        {formatAmountComma(
                          totalDollerValue +
                            (shouldShowLockedTrainingRows ? lockedTrainingCostTotal : 0)
                        )}
                      </div>
                      <div className="w-[25%] border p-2"></div>
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  {triprows.map((row, index) => (
                    <React.Fragment key={index}>
                      {Assignperson?.taskStatus === "submit"
                        ? (
                          <div className="flex items-center text-center w-full text-xs">
                            <div className="w-full">
                              <div className="head flex">
                                <div className="w-[10%] border p-1">
                                  {index + 1}
                                </div>

                                <div className="w-[40%] border p-2">
                                  {row.description}
                                </div>

                                <div className="w-[25%] border p-2">
                                  {formatAmountComma(row.value)}
                                </div>

                                <div className="w-[25%] border p-2">
                                  {row.notes}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex items-center text-center w-full text-xs">
                            <div className="w-full">
                              <div className="head flex">
                                <div className="w-[10%] border p-1">
                                  {index + 1}
                                </div>

                                <div className="w-[40%] border p-2">
                                  <input
                                    type="text"
                                    name="description"
                                    value={row.description}
                                    onChange={(e) =>
                                      handleTripInputChange(
                                        index,
                                        "description",
                                        validateDescriptionOrNotes(e.target.value)
                                      )
                                    }
                                    placeholder="Enter Description"
                                    className="outline-none border-none text-center w-full h-full"
                                  />
                                </div>

                                <div className="w-[25%] border p-2">
                                  <input
                                    type="text"
                                    name="value"
                                    value={formatAmountForInput(row.value)}
                                    onFocus={(e) => {
                                      if (e.target.value === "0") e.target.select();
                                    }}
                                    onClick={(e) => {
                                      if (e.target.value === "0") e.target.select();
                                    }}
                                    onChange={(e) =>
                                      handleTripInputChange(
                                        index,
                                        "value",
                                        validateAmountValue(e.target.value)
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (["e", "E", "+", "-"].includes(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                    className="outline-none border-none text-center w-full h-full"
                                  />
                                </div>

                                <div className="w-[25%] border p-2">
                                  <input
                                    type="text"
                                    name="notes"
                                    value={row.notes}
                                    placeholder="Enter Notes"
                                    onChange={(e) =>
                                      handleTripInputChange(
                                        index,
                                        "notes",
                                        validateDescriptionOrNotes(e.target.value)
                                      )
                                    }
                                    className="outline-none border-none text-center w-full h-full"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                    </React.Fragment>
                  ))}

                  {shouldShowLockedTrainingRows && lockedTrainingRow && (
                    <div className="flex items-center text-center w-full text-xs">
                      <div className="w-full">
                        <div className="head flex">
                          <div className="w-[10%] border p-1">{triprows.length + 1}</div>
                          <div className="w-[40%] border p-2">
                            <input
                              type="text"
                              value={lockedTrainingRow.description}
                              disabled
                              className="outline-none border-none text-center w-full h-full bg-[#e5e7eb] text-[#6b7280] cursor-not-allowed"
                            />
                          </div>
                          <div className="w-[25%] border p-2">
                            <input
                              type="text"
                              value={formatAmountComma(lockedTrainingRow.amount)}
                              disabled
                              className="outline-none border-none text-center w-full h-full bg-[#e5e7eb] text-[#6b7280] cursor-not-allowed"
                            />
                          </div>
                          <div className="w-[25%] border p-2">
                            <input
                              type="text"
                              value={lockedTrainingRow.notes}
                              disabled
                              className="outline-none border-none text-center w-full h-full bg-[#e5e7eb] text-[#6b7280] cursor-not-allowed"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {Assignperson?.taskStatus === "submit" ? null : (
                    <div className="flex justify-between px-2 pt-1">
                      <button
                        className="shadow-xl rounded-md p-1"
                        onClick={handleAddRow}
                        disabled={triprows.length >= 15}
                      >
                        <AddIcon />
                      </button>
                      <button
                        className="shadow-xl rounded-md p-1"
                        onClick={() => handleRemoveRow(lastEditableTripRowIndex)}
                        disabled={lastEditableTripRowIndex < 0}
                      >
                        <RemoveIcon />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        }

        {Assignperson?.taskStatus === "submit" ? (
          <></>
        ) : (
          <div className="flex gap-2 w-auto justify-end py-1">
            {isLoadingtask && (
              <div className="mt-4 flex gap-1 align-middle items-center">
                <div className="text-sm">Saving Tasks </div>
                <SubmitLoader isLoadingtask={isLoadingtask} />
              </div>
            )}
            {(() => {
              const hasValidHardwareEntry = hardware.some(
                (item) =>
                  (item.assemblepartdescription && String(item.assemblepartdescription).trim() !== "") &&
                  item.quantity &&
                  Number(item.quantity) > 0
              );
              const canShowSubmit = filteredEntries?.length > 0 || hasValidHardwareEntry;
              return canShowSubmit ? (
                <button
                  disabled={row.taskStatus === "autosave"}
                  onClick={() => handleAction()}
                  className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md"
                >
                  Submit
                </button>
              ) : null;
            })()}
          </div>
        )}
      </div >
    </>
  );
};

export default ManagerHardware;
